import slider1 from '../assets/images/slider1.jpg';
import slider2 from '../assets/images/slider2.jpg';
import slider3 from '../assets/images/slider3.jpg';

export const sliderInfo = [
	{
		img: slider1,
		title: 'ENJOY YOUR ME',
		desc: 'Good food is wise',
		subDesc: 'medicine',
	},

	{
		img: slider2,
		title: 'HAPPY YOUR SPECIAL',
		desc: 'Love at first',
		subDesc: 'bite',
	},

	{
		img: slider3,
		title: 'GOOD FOOD IS GOOD MOOD',
		desc: 'The belly rules the',
		subDesc: 'mind',
	},
];
